<div *ngIf="!trustedByHosptial" class="wrapper text-center">
  <h3>Trusted By</h3>
  <div class="container d-flex justify-content-between w-100 img-wrapper">
    <div>
      <img class="amazon" loading="lazy" data-src="/assets/images/thank-you/amazon.png" />
    </div>
    <div>
      <img class="cry" loading="lazy" data-src="/assets/images/thank-you/cry.png" />
    </div>
    <div>
      <img class="mission-oxygen" loading="lazy" data-src="/assets/images/thank-you/mission-oxygen.png" />
    </div>
    <div>
      <img class="habitat" loading="lazy" data-src="/assets/images/thank-you/habitat.png" />
    </div>
    <div>
      <img class="cry" loading="lazy" data-src="/assets/images/thank-you/cry.png" />
    </div>
  </div>
</div>

<div class="hospital-wrapper">
  <div *ngIf="trustedByHosptial" class="hospital">
    <div class="title">Our Partner Hospitals</div>
    <div class="img-wrapper">
      <div class="image">
        <img class="reliance" loading="lazy" data-src="/assets/images/trusted-by/reliance.png" />
      </div>
      <div class="image">
        <img class="kem-pune" loading="lazy" data-src="/assets/images/trusted-by/kem-pune.png" />
      </div>
      <div class="image">
        <img class="nanavati" loading="lazy" data-src="/assets/images/trusted-by/nanavati.png" />
      </div>
    </div>
  </div>
</div>
